import siteType from "./siteType";

// obj { ip, legal, platform }
export function setLicenseType(obj) {
  console.log('setLicenseType');
  console.log(obj);

  // return ;
  
  
  // forceLegal from url forceLegal=4
  const forceLegal = getParam("forceLegal");
  const key = forceLegal || obj.legal;
  // save legal type to localStorage
  const legal = {
    ip: obj.ip,
    legal: key,
    platform: obj.platform,
    timestamp: Date.now(),
  };
  if (siteType.GetSiteType() != siteType.SITE_TYPE_NUTS) {
    switch (key) {
      case 1: // 1: 合法
      case 3:
        // 曼岛
        window.currentType = "mannin";
        break;
      case 4:
        // 库拉索
        window.currentType = "curacao";
        break;
      case 7:
        // 丹麦
        window.currentType = "denmark";
        break;
      // 0：非法
      // 2：判斷網路不穩定非法
      default:
        // window.location.href = `${process.env.VUE_APP_NOTICE_KKPOKER}/pc/restricted_prompt`;
        window.location.href = `${process.env.VUE_APP_KKPOKER_OFFICE}`
        window.currentType = "all_block";
        break;
    }
    legal.currentType = window.currentType;
  } else {
    switch (key) {
      case 1:
      case 5:
        break;
      default:
        window.location.replace(
          `${process.env.VUE_APP_OFFICE}/restrictedprompt`
        );
        window.currentType = "all_block";
        break;
    }
  }
  localStorage.setItem("legal", JSON.stringify(legal));
}

function getParam(params) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  // parse to int
  return +urlParams.get(params);
}
